export enum Region {
  GLOBAL = "Global",
  UNITED_STATES = "United States",
  JAPAN = "Japan",
  UNITED_KINGDOM = "United Kingdom",
  GERMANY = "Germany",
  FRANCE = "France",
  EU5 = "EU5"
}
